<template>
  <section class="blaFifthSection">
    <!-- <div class="row pa-2">
      <div class="col-10 offset-1 col-md-8 offset-md-2">
        <div class="row">
          <div class="col-12 text-center justify-center"> -->
            <!-- <div class="blaFifthSectionTitle">
              Most kezded a tanulást vagy már folyékonyan beszélsz angolul/németül?
              Ezt akkor is imádni fogod!
            </div> -->

            <!-- <div class="blaFifthSectionDescription">
              Most kezded a tanulást vagy már folyékonyan beszélsz angolul? Ezt
              akkor is imádni fogod!
            </div> -->

            <!-- <div
              class="clickable mt-3 blaPrimaryButton text-center py-3 justify-center pl-50"
              @click="$router.push({ name: 'registration' })"
            >
              <span class="px-3 py-3">
                Kezdés
              </span>
            </div> -->
          <!-- </div>
        </div>
      </div>
    </div> -->
    <div class="row">
      <div class="col-10 offset-1 col-md-6 offset-md-3 text-center mt-4">
        <div class="blaPackagesTitle">
          Áraink
        </div>
        <div class="row align-content-center mt-2 mb-1">
          <div class="col-12 col-md-6">
            <div class="blaPackagesBox blaPackagesBoxWhite">
              <div class="blaPackagesBoxHeader">
                <div class="blaPackagesBoxTitle">
                  Skillers At Work
                  <br>
                  Ingyenes Próba
                  <hr />
                </div>
              </div>
              <div class="blaPackagesBoxContent">
                <div class="row">
                  <div class="col-3 text-right">
                    <img
                      :src="require('@/assets/img/check.png')"
                      alt="check_icon"
                      class="blaPackagesImg"
                    />
                  </div>
                  <div class="col-9 text-left blaPackagesBoxContentStrong">
                    Hozzáférés a próbaleckékhez
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-3 text-right">
                    <img
                      :src="require('@/assets/img/lock_purple.png')"
                      alt="lock_icon"
                      class="blaPackagesImg"
                    />
                  </div>
                  <div class="col-9 text-left">
                    Hozzáférés az összes angol tanfolyamhoz
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-3 text-right">
                    <img
                      :src="require('@/assets/img/lock_purple.png')"
                      alt="lock_icon"
                      class="blaPackagesImg"
                    />
                  </div>
                  <div class="col-9 text-left">
                    Vállalati arculat
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-3 text-right">
                    <img
                      :src="require('@/assets/img/lock_purple.png')"
                      alt="lock_icon"
                      class="blaPackagesImg"
                    />
                  </div>
                  <div class="col-9 text-left">
                    Vállalati ranglista
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-3 text-right">
                    <img
                      :src="require('@/assets/img/lock_purple.png')"
                      alt="lock_icon"
                      class="blaPackagesImg"
                    />
                  </div>
                  <div class="col-9 text-left">Hozzáférés a frissülő üzleti angol leckékhez</div>
                </div>
                <div class="row my-5 pt-5 pb-3">
                  <div class="col-8 offset-2 text-center" style="font-weight: 700;">
                    Ingyenes
                  </div>
                </div>
                <div class="row my-5 pt-5 pb-3">
                  <div class="col-8 offset-2">
                    <div
                      @click="$router.push({ name: 'registration' })"
                      class="blaPackagesButton"
                    >
                      Kipróbálom
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="blaPackagesBox blaPackagesBoxPurple">
              <div class="blaPackagesBoxHeader">
                <div class="blaPackagesBoxTitlePurple">
                  Skillers At Work
                  <br />
                  PRÉMIUM
                  <hr />
                </div>
              </div>
              <div class="blaPackagesBoxContent">
                <div class="row mt-3">
                  <div class="col-3 text-right">
                    <img
                      :src="require('@/assets/img/check_white.png')"
                      alt="lock_icon"
                      class="blaPackagesImg"
                    />
                  </div>
                  <div class="col-9 text-left blaPackagesBoxContentStrong">
                    Hozzáférés az összes angol tanfolyamhoz
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-3 text-right">
                    <img
                      :src="require('@/assets/img/check_white.png')"
                      alt="lock_icon"
                      class="blaPackagesImg"
                    />
                  </div>
                  <div class="col-9 text-left blaPackagesBoxContentStrong">
                    Vállalati arculat
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-3 text-right">
                    <img
                      :src="require('@/assets/img/check_white.png')"
                      alt="lock_icon"
                      class="blaPackagesImg"
                    />
                  </div>
                  <div class="col-9 text-left blaPackagesBoxContentStrong">
                    Vállalati ranglista
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-3 text-right">
                    <img
                      :src="require('@/assets/img/check_white.png')"
                      alt="lock_icon"
                      class="blaPackagesImg"
                    />
                  </div>
                  <div class="col-9 text-left blaPackagesBoxContentStrong">
                    Hozzáférés a frissülő üzleti angol leckékhez
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-3 text-right">
                    <img
                      :src="require('@/assets/img/check_white.png')"
                      alt="lock_icon"
                      class="blaPackagesImg"
                    />
                  </div>
                  <div class="col-9 text-left blaPackagesBoxContentStrong">
                    Jelentések készítése
                    <br>
                  </div>
                </div>
                <div class="row my-5 pt-5 pb-3">
                  <div class="col-8 offset-2 text-center" style="font-weight: 700;">
                    2.500 Ft-tól /hó/tanuló
                  </div>
                </div>
                <div class="row my-5 pt-5">
                  <div class="col-8 offset-2">
                    <div
                      @click="sendEmail"
                      class="blaPackagesButton"
                    >
                      Kérjen ajánlatot
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  components: {},
  data: () => ({}),
  methods: {
    sendEmail() {
      window.location = 'mailto:info@e-egyetem.hu';
    }
  },
  props: {},
  mounted: () => ({})
};
</script>
